import { deepmerge } from '@utils/deepmerge'

export const buildChartJsOptionsProp = (options) => {
  return deepmerge({
    responsive: true,
    maintainAspectRatio: true,
    cutout: '40%',
    circumference: 360,
    elements: {
      arc: {
        borderWidth: 0,
        spacing: 0
      }
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: true,
      },
      datalabels: {
        display: false
      }
    }
  }, options)
}
